// Unwyndly — scripts propios (vanilla, sin librerias)

function initReveal() {
  const els = document.querySelectorAll('.uw-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('uw-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('uw-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => observer.observe(el));
}

function initCountUp() {
  const els = document.querySelectorAll('[data-uw-countup]');
  if (!els.length) return;
  const animate = (el) => {
    const target = parseFloat(el.dataset.uwCountup);
    const decimals = el.dataset.uwDecimals ? parseInt(el.dataset.uwDecimals, 10) : 0;
    const duration = 1200;
    const start = performance.now();
    function tick(now) {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  };
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => observer.observe(el));
}

function initGallery() {
  const galleries = document.querySelectorAll('[data-uw-gallery]');
  galleries.forEach((gallery) => {
    const main = gallery.querySelector('[data-uw-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-uw-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.uwFull;
        if (src === main.src || thumb.classList.contains('is-active')) return;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        main.classList.add('is-swapping');
        const preload = new Image();
        preload.onload = () => {
          main.src = src;
          requestAnimationFrame(() => main.classList.remove('is-swapping'));
        };
        preload.src = src;
      });
    });
  });
}

function initVariants() {
  const forms = document.querySelectorAll('.uw-product-form');
  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-uw-variants-json]');
    const submitBtn = form.querySelector('[data-uw-submit]');
    if (!dataEl || !submitBtn) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = form.querySelector('[data-uw-price]');
    const compareEl = form.querySelector('[data-uw-compare-price]');
    const options = form.querySelectorAll('[data-uw-option]');
    const sectionRoot = form.closest('[id^="shopify-section-"]') || document;
    const mainImg = sectionRoot.querySelector('[data-uw-gallery-main]');
    const thumbs = sectionRoot.querySelectorAll('[data-uw-gallery-thumb]');

    function swapMainImage(src) {
      if (!mainImg || !src || mainImg.src.split('?')[0] === src.split('?')[0]) return;
      mainImg.classList.add('is-swapping');
      const preload = new Image();
      preload.onload = () => {
        mainImg.src = src;
        requestAnimationFrame(() => mainImg.classList.remove('is-swapping'));
      };
      preload.src = src;
      const targetName = src.split('?')[0].split('/').pop();
      thumbs.forEach((t) => {
        const thumbName = (t.dataset.uwFull || '').split('?')[0].split('/').pop();
        t.classList.toggle('is-active', !!thumbName && thumbName === targetName);
      });
    }

    function money(cents) {
      const probe = submitBtn.dataset.uwDecimalProbe || '';
      const sep = (probe.match(/(\D)\d{2}\D*$/) || [, '.'])[1];
      return submitBtn.dataset.uwMoneyFormat.replace(
        '{{amount}}',
        (cents / 100).toFixed(2).replace('.', sep)
      );
    }

    function currentSelection() {
      return Array.from(options).map((group) => group.querySelector('.is-selected')?.dataset.uwValue);
    }

    function findVariant() {
      if (!options.length) return variants[0];
      const sel = currentSelection();
      return variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }

    const btnText = submitBtn.querySelector('[data-uw-btn-text]') || submitBtn;

    function updateUI() {
      const variant = findVariant();
      if (!variant) {
        submitBtn.disabled = true;
        btnText.textContent = submitBtn.dataset.uwUnavailableText;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      submitBtn.disabled = !variant.available;
      btnText.textContent = variant.available ? submitBtn.dataset.uwAddText : submitBtn.dataset.uwSoldOutText;
      if (variant.featured_image) swapMainImage(variant.featured_image.src);
    }

    options.forEach((group) => {
      group.querySelectorAll('[data-uw-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('[data-uw-value]').forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          updateUI();
        });
      });
    });

    updateUI();
  });
}

function initTilt() {
  const els = document.querySelectorAll('.uw-tilt');
  if (!els.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  els.forEach((el) => {
    el.addEventListener('mousemove', (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(700px) rotateX(${(-py * 6).toFixed(2)}deg) rotateY(${(px * 6).toFixed(2)}deg) translateY(-4px)`;
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = '';
    });
  });
}

function initParallax() {
  const wraps = document.querySelectorAll('[data-uw-parallax]');
  if (!wraps.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const els = Array.from(wraps)
    .map((wrap) => ({ wrap, img: wrap.querySelector('img'), strength: parseFloat(wrap.dataset.uwParallax) || 0.08 }))
    .filter((e) => e.img);
  let ticking = false;
  function update() {
    els.forEach(({ wrap, img, strength }) => {
      const r = wrap.getBoundingClientRect();
      const center = r.top + r.height / 2 - window.innerHeight / 2;
      img.style.transform = `translateY(${(-center * strength).toFixed(1)}px)`;
    });
    ticking = false;
  }
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
  update();
}

function initCarousel() {
  document.querySelectorAll('[data-uw-carousel]').forEach((track) => {
    const wrap = track.closest('.uw-container') || track.parentElement;
    const prev = wrap.querySelector('[data-uw-carousel-prev]');
    const next = wrap.querySelector('[data-uw-carousel-next]');

    const cardWidth = () => {
      const card = track.querySelector('.uw-test__card');
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    };
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const step = (dir) => {
      if (dir > 0 && atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && track.scrollLeft <= 4) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: dir * cardWidth(), behavior: 'smooth' });
      }
    };

    if (prev) prev.addEventListener('click', () => { step(-1); startAutoplay(); });
    if (next) next.addEventListener('click', () => { step(1); startAutoplay(); });

    const autoplayMs = parseInt(track.dataset.uwCarouselAutoplay, 10);
    let timer = null;
    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (!autoplayMs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(() => step(1), autoplayMs);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }
    if (autoplayMs) {
      startAutoplay();
      wrap.addEventListener('mouseenter', stopAutoplay);
      wrap.addEventListener('mouseleave', startAutoplay);
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', startAutoplay);
    }
  });
}

function initQtyStepper() {
  document.querySelectorAll('[data-uw-qty-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('.uw-prod__qty');
    const decreaseBtn = stepper.querySelector('[data-uw-qty-decrease]');
    const increaseBtn = stepper.querySelector('[data-uw-qty-increase]');
    if (!input || !decreaseBtn || !increaseBtn) return;

    const min = parseInt(input.min, 10) || 1;

    function clampAndSync() {
      const clamped = Math.max(min, parseInt(input.value, 10) || min);
      input.value = clamped;
      decreaseBtn.disabled = clamped <= min;
    }

    function step(delta) {
      input.value = (parseInt(input.value, 10) || min) + delta;
      clampAndSync();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    decreaseBtn.addEventListener('click', () => step(-1));
    increaseBtn.addEventListener('click', () => step(1));
    input.addEventListener('input', clampAndSync);

    clampAndSync();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initCountUp();
  initGallery();
  initVariants();
  initTilt();
  initParallax();
  initCarousel();
  initQtyStepper();
});
